import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule, } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { FormSaveManagerComponent } from '../../../components/form-save-manager/form-save-manager.component';

import { TabViewModule } from 'primeng/tabview';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { SplitterModule } from 'primeng/splitter';
import { MenubarModule } from 'primeng/menubar';
import { MessageService } from 'primeng/api';
import { Form } from 'lib-base';
import { FormularioService } from '../../../services/database/formulario.service';
import { TranslateModule } from '@ngx-translate/core';
import { FormViewerComponent } from '../../../components/form-builder-components/form-viewer/form-viewer.component';
import { FormDesignerContainerComponent } from './form-designer-container.component';

@Component({
  selector: 'app-edit-form',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    FormSaveManagerComponent, FormViewerComponent, FormDesignerContainerComponent,
    TabViewModule, ScrollPanelModule, SidebarModule, ButtonModule, MenubarModule, TranslateModule
  ],
  styleUrls: ['../../../../assets/styles/style.mantenimiento.scss'],
  template: `
  <section class="flex justify-content-center mt-4">
    <div class="card-table col-12">
      <div class="flex flex-column">
        @if(isDesignerInitialized && !hideSaveManager){
          <app-form-save-manager [form]="designerComponent.fc.LoadedForm" [fc]="designerComponent.fc"></app-form-save-manager>
        }

        <p-tabView (activeIndexChange)="onIndexChanged($event)">
          <p-tabPanel [header]="'dynamic-form.tabs.disenador' | translate">
            <app-form-designer-container></app-form-designer-container>
          </p-tabPanel>
          <p-tabPanel [header]="'dynamic-form.tabs.vista-previa' | translate">
            <p-scrollPanel [style]="scrollPanel">
              <app-form-viewer></app-form-viewer>
            </p-scrollPanel>
          </p-tabPanel>
          <p-tabPanel [header]="'dynamic-form.tabs.json-editor' | translate">
            <p-scrollPanel [style]="scrollPanel" *ngIf="isDesignerInitialized">
              <pre>{{ designerComponent.fc.Form.toJSON() | json }}</pre>
            </p-scrollPanel>
          </p-tabPanel>
          <p-tabPanel [header]="'dynamic-form.tabs.json-formulario' | translate">
            <p-scrollPanel [style]="scrollPanel" *ngIf="isDesignerInitialized">
              <pre>{{ designerComponent.fc.Form.getFormValues() | json }}</pre>
            </p-scrollPanel>
          </p-tabPanel>
        </p-tabView>

      </div>
    </div>
  </section>
  `
})

export default class EditFormComponent implements AfterViewInit {
  scrollPanel: any = { width: '100%', height: '65vh' };
  isDesignerInitialized: boolean = false;
  hideSaveManager: boolean = false;
  @ViewChild(FormSaveManagerComponent) saveComponent !: FormSaveManagerComponent;
  @ViewChild(FormDesignerContainerComponent) designerComponent !: FormDesignerContainerComponent;
  @ViewChild(FormViewerComponent) viewerComponent !: FormViewerComponent;

  private _formData !: Form;
  private _initForm !: boolean;

  constructor(private _fs: FormularioService, private route: ActivatedRoute, public messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {
    const formId = Number(this.route.snapshot.params['formId']);
    const version = Number(this.route.snapshot.params['version']);
    if (formId) {
      if(version){
        this.hideSaveManager = true;
        this._fs.findByIdAndVersion(formId, version).subscribe({
          next: (response: Form) => {
            this._initForm = false;
            this._formData = response;
            this.designerComponent.loadForm(response);
            this.viewerComponent.loadForm(response);
            this.isDesignerInitialized = true;
            this.cdr.detectChanges();
          }
        });
      }else{
        this._fs.getForm(formId).subscribe({
          next: (response: Form) => {
            this._initForm = false;
            this._formData = response;
            this.designerComponent.loadForm(response);
            this.viewerComponent.loadForm(response);
            this.isDesignerInitialized = true;
            this.cdr.detectChanges();
          }
        });
      }
    } else {
      this._initForm = true;
    }
  }

  ngAfterViewInit(): void {
    if(this._initForm){
      this.designerComponent.initializeNewForm();
      this.viewerComponent.initializeNewForm();
      this.isDesignerInitialized = true;
      this.cdr.detectChanges();
    }
  }

  onIndexChanged($event: number) {
    if ($event === 1) {
      //esto es para sincronizar la vista previa con el diseñador
      if(!this._formData){
        this._formData ={
          contenido: JSON.stringify(this.designerComponent.fc.Form.toJSON())
        } as Form
      }else{
        this._formData.contenido = JSON.stringify(this.designerComponent.fc.Form.toJSON());
      }
      this.viewerComponent.loadForm(this._formData);
    }
  }
}